import './Section.scss'

import classNames from 'classnames'
import React, { HTMLProps } from 'react'

export interface SectionProps extends HTMLProps<HTMLDivElement> {
  className?: string
}

export default function Section(props: SectionProps) {
  const { className, ...otherProps } = props
  const mergedClassName = classNames('section', className)

  return <div className={mergedClassName} {...otherProps} />
}
